import type { SVGProps } from 'react';
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      d="M19.999 3.2a2.803 2.803 0 0 1 2.799 2.791V18c0 1.542-1.257 2.8-2.799 2.8h-16a2.806 2.806 0 0 1-2.8-2.8V5.985l.005-.076A2.803 2.803 0 0 1 4 3.2zm-7.541 10.455a.8.8 0 0 1-.918 0L2.799 7.536V18c0 .658.542 1.2 1.2 1.2h16c.658 0 1.2-.542 1.2-1.2V7.536zM3.999 4.8c-.528 0-.98.348-1.14.826L12 12.023l9.139-6.397a1.21 1.21 0 0 0-1.139-.826z"
    />
  </svg>
);
export default SvgMail;
